
<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-container>
      <h4>Süt Tipi Detayı</h4>
      <v-row style="margin-top:100px;">
        <v-col cols="12" md="4">
          <h4>Başlık</h4>
          <v-text-field v-model="milkTypeData.milkType" :rules="titleRules" required></v-text-field>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="4">
          <h4>Aktif/Pasif</h4>
          <v-checkbox v-model="milkTypeData.active"></v-checkbox>
        </v-col>
        <v-col cols="12" md="8"></v-col>

        <v-col cols="12" md="7">
          <v-btn
            depressed
            color="primary"
            style="text-transform: none !important;float:right;"
            @click="milkTypeUpdate()"
          >GÜNCELLE</v-btn>
        </v-col>
      </v-row>

      <!-- <v-row>
          
      </v-row>-->
    </v-container>
  </v-form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "MilkTypeDetails",
  computed: mapGetters(["milkTypeData"]),
  methods: {
    ...mapActions(["getMilkType","updateMilkType"]),
    routeMilkTypes() {
      this.$router.push("/dashboard/productCategories/milkTypes");
    },
    milkTypeUpdate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
        this.updateMilkType(this.milkTypeData).then(response=>{
          console.log(response)
          if(response.processStatus == "Success") {
            this.routeMilkTypes();
          }
        });
      }
    }
  },
  data: () => ({
    dialog: false,
    valid: true,
    titleRules: [v => !!v || "Başlık alanı zorunludur."],
  }),
  created() {
    let id = this.$route.params.id;

    this.getMilkType(id);
  },
};
</script>
